import ajaxRequest from './ajax'
import qs from "qs"

export const get_session_detail = params => {
    return ajaxRequest.get("noauth/get_session_detail?" + qs.stringify(params))
}

export const get_event_detail = params => {
    return ajaxRequest.get("noauth/get_event_detail?" + qs.stringify(params))
}

// 判断用户是否是新老用户 verify_user
export const verify_user = params => {
  return ajaxRequest.get("noauth/verify_user?"+qs.stringify(params))
}
// 判断用户密码是否正确 verify_pwd
export const verify_password = params => {
  return ajaxRequest.get("noauth/verify_password?"+qs.stringify(params))
}



// WEBPACK FOOTER //
// ./src/api/noauth.js